<template>
  <app-layout>
    <v-card class="ma-3 pa-3">
      <!-- Resume -->
      <v-card-title class="pt-0">
        <v-layout row wrap>
          <v-flex xs12 md4>
            <v-layout align-center justify-start row fill-height>
              <div>
                <h2>Ventas</h2>
              </div>
              <div class="ml-3">
                <v-select
                  class="fit"
                  color="primary"
                  v-model="selectedYear"
                  item-text="text"
                  item-value="value"
                  :items="years"
                ></v-select>
              </div>
              <div class="ml-3">
                <v-select
                  class=""
                  color="primary"
                  v-model="selectedQuarter"
                  item-text="text"
                  item-value="value"
                  :items="quarters"
                ></v-select>
              </div>
            </v-layout>
          </v-flex>
          <v-flex xs12 md8>
            <!-- Action buttons -->
            <v-layout align-center justify-end row fill-height>
              <div v-if="selectedTableItems.length >= 1">
                <v-btn color="error" @click="showBulkDeleteInvoiceModal = true">
                  <v-icon left>mdi-delete</v-icon>
                  {{ $t('ELIMINAR') }}
                </v-btn>
                <v-btn color="info" @click="onBulkDownloadPdf()">
                  <v-icon left>mdi-download</v-icon>
                  {{ $t('DESCARGAR PDF') }}
                  <v-progress-circular
                    v-if="downloadingPDF"
                    class="ml-2"
                    :size="20"
                    indeterminate
                    color="black"
                  ></v-progress-circular>
                </v-btn>
                <v-btn color="light" @click="exportToExcel()" :disabled="exportingExcel">
                  <v-icon left>mdi-file-excel-outline</v-icon>
                  {{ $t('Exportar a excel') }}
                  <v-progress-circular
                    v-if="exportingExcel"
                    class="ml-2"
                    :size="20"
                    indeterminate
                    color="black"
                  ></v-progress-circular>
                </v-btn>
              </div>
              <div>
                <v-btn color="secondary" @click="openImportInvoicesModal()">
                  <v-icon left>mdi-upload</v-icon>
                  {{ $t('IMPORTAR FACTURAS') }}
                </v-btn>
              </div>
              <div>
                <v-btn color="primary" @click="openNewInvoiceForm()">
                  <v-icon left>mdi-plus</v-icon>
                  {{ $t('CREAR FACTURA') }}
                </v-btn>
              </div>
            </v-layout>
            <!-- End action buttons -->
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-card-text>
        <open-billing-invoice-table
          ref="openbillingInvoiceTable"
          :year="selectedYear"
          :quarter="selectedQuarter"
          invoice-type="factura"
          @on-selected-items="onSelectedItems($event)"
          @on-edit-invoice="onEditInvoice($event)"
          @on-delete-invoice="onDeleteInvoice($event)"
          @on-rectify-invoice="onRectifyInvoice($event)"
          @on-clone-invoice="onCloneInvoice($event)"
          @on-download-pdf="onDownloadPdf($event)"
          @on-send-by-email="sendInvoiceByEmail($event)"
        ></open-billing-invoice-table>
      </v-card-text>
    </v-card>
    <open-billing-invoice-form
      v-if="showInvoiceModalForm"
      :show-modal="showInvoiceModalForm"
      :key="`inv-form-${invoiceFormKey}`"
      :invoice-id="selectedInvoiceId"
      invoice-type="factura"
      :rectify-invoice-id="rectifyInvoiceId"
      :clone-invoice-id="cloneInvoiceId"
      @click-on-close="closeInvoiceModalForm()"
      @on-saved-invoice="onSavedInvoice()"
      @on-delete-invoice="deleteSingleInvoice($event)"
    ></open-billing-invoice-form>
    <!-- Modal to delete invoices -->
    <v-layout row justify-center>
      <v-dialog v-model="showDeleteInvoiceModal" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">{{ $t('Eliminar') }}</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 class="text-xs-center">
                  <h2>
                    ¿Estás seguro de eliminar la factura seleccionada?
                  </h2>
                  <small>Esta acción no es reversible</small>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="closeDeleteInvoiceModal()">
              {{ $t('Cerrar') }}
            </v-btn>
            <v-btn color="error" @click="confirmDeleteInvoice()">
              {{ $t('Eliminar') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- End modal -->
    <!-- Modal to send invoice by email -->
    <v-layout row justify-center>
      <v-dialog v-model="showSendInvoiceEmailModal" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">{{ $t('Enviar factura') }}</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-form ref="invoiceEmailForm">
                <v-layout wrap>
                  <v-flex xs12 class="text-xs-center">
                    <v-text-field
                      class="pl-2"
                      v-model="summaryInvoiceEmail"
                      label="Factura"
                      readonly
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 class="text-xs-center">
                    <v-text-field
                      class="pl-2"
                      v-model="formInvoiceEmail.title"
                      :rules="[rules.required]"
                      label="Título"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 class="text-xs-center">
                    <v-textarea
                      box
                      v-model="formInvoiceEmail.body"
                      :rules="[rules.required]"
                      label="Mensaje"
                    ></v-textarea>
                  </v-flex>
                  <v-flex xs12 class="text-xs-center">
                    <v-text-field
                      class="pl-2"
                      v-model="formInvoiceEmail.receivers"
                      :rules="[rules.email]"
                      label="Enviar a"
                      type="email"
                    ></v-text-field>
                  </v-flex>
                  <!--<v-flex
                    v-for="(receiver, index) in formInvoiceEmail.receivers"
                    :key="`${selectedInvoiceToSendByEmail.id}--${index}`"
                    xs12
                    class="text-xs-center"
                  >
                    <v-text-field
                      ref="invoiceEmailFormReceiver"
                      class="pl-2"
                      v-model="formInvoiceEmail.receivers[index]"
                      :rules="[rules.email]"
                      label="Enviar a"
                      type="email"
                    ></v-text-field>
                  </v-flex>-->
                </v-layout>
              </v-form>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              :disabled="sendingInvoiceEmail"
              color="blue darken-1"
              flat
              @click="onCloseSendInvoiceEmail"
            >
              {{ $t('Cerrar') }}
            </v-btn>
            <v-btn
              :disabled="sendingInvoiceEmail"
              color="success"
              @click="confirmSendInvoiceByEmail()"
            >
              <v-progress-circular
                v-if="sendingInvoiceEmail"
                class="ml-2 mr-2"
                :size="20"
                indeterminate
                color="black"
              ></v-progress-circular>
              <template v-if="!sendingInvoiceEmail">
                {{ $t('Enviar') }}
              </template>
              <template v-else>
                {{ $t('Enviando...') }}
              </template>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- End modal -->
    <!-- Modal to delete bulk contacts -->
    <v-layout row justify-center>
      <v-dialog v-model="showBulkDeleteInvoiceModal" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">{{ $t('Eliminar') }}</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 class="text-xs-center">
                  <h2>
                    ¿Estás seguro de eliminar las ventas seleccionadas?
                  </h2>
                  <p>Las facturas que estén contabilizadas por el asesor no serán eliminadas</p>
                  <small>Esta acción no es reversible</small>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="showBulkDeleteInvoiceModal = false">
              {{ $t('Cerrar') }}
            </v-btn>
            <v-btn color="error" @click="confirmDeleteBulkInvoices()">
              {{ $t('Eliminar') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- End modal -->
    <!-- Generate pdf for selected invoices -->
    <v-layout row wrap v-if="downloadingPDF || sendingInvoiceEmail">
      <v-flex xs12 class="ma-3">
        <v-expansion-panel>
          <v-expansion-panel-content>
            <template v-slot:header>
              <div v-if="downloadingPDF">Descargando PDF</div>
              <div v-else-if="sendingInvoiceEmail">Enviando factura por email</div>
              <v-progress-linear :indeterminate="true" style="width: 85%"></v-progress-linear>
            </template>
            <open-billing-generate-invoice-pdf
              id="element-to-print"
              class="ma-0 pa-0"
              :invoices="selectedInvoicesToGeneratePDF"
              invoice-type="factura"
              :invoice-logo="invoiceLogo"
              :key="`gen-pdf-${resetGeneratePdfKey}`"
            ></open-billing-generate-invoice-pdf>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>
    </v-layout>
    <!-- Modal to import invoices -->
    <open-billing-import-invoice-modal
      :key="`import-inv-${keyImportInvoicesModal}`"
      :show-modal="showImportInvoicesModal"
      @click-on-close="closeImportInvoicesModal()"
      @on-saved-invoices="onImportedInvoices()"
    ></open-billing-import-invoice-modal>
    <v-snackbar v-model="snack" bottom right :timeout="3000" :color="snackColor">
      {{ snackText }}
    </v-snackbar>
  </app-layout>
</template>

<script>
import AppLayout from '@/views/layouts/AppLayout';
import OpenBillingInvoiceTable from '@/modules/openbilling/components/OpenBillingInvoiceTable';
import OpenBillingInvoiceForm from '@/modules/openbilling/components/OpenBillingInvoiceForm';
import apiCtrl from '@/services/api/abstract/abstract-api';
import html2pdf from 'html2pdf.js';
import OpenBillingGenerateInvoicePdf from '../components/OpenBillingGenerateInvoicePDF';
import OpenBillingImportInvoiceModal from '../components/OpenBillingImportInvoiceModal';
import {
  createEmptyTotalSelectedInvoiceData,
  generateCalculatedTotalSelectedInvoice,
} from '@/modules/openbilling/helpers/invoiceHelper';

export default {
  name: 'OpenBillingInvoiceList',
  components: {
    OpenBillingImportInvoiceModal,
    OpenBillingGenerateInvoicePdf,
    AppLayout,
    'open-billing-invoice-table': OpenBillingInvoiceTable,
    'open-billing-invoice-form': OpenBillingInvoiceForm,
  },
  props: [],
  data() {
    return {
      selectedYear: new Date().getFullYear(),
      years: [],
      quarters: [
        {
          text: 'Año completo',
          value: null,
        },
        {
          text: '1er Trimestre',
          value: 1,
        },
        {
          text: '2o Trimestre',
          value: 2,
        },
        {
          text: '3er Trimestre',
          value: 3,
        },
        {
          text: '4o Trimestre',
          value: 4,
        },
      ],
      selectedQuarter: null,
      totalAmountInvoiced: 0,
      totalAmountWithoutPay: 0,
      showInvoiceModalForm: false,
      keyImportInvoicesModal: 0,
      showDeleteInvoiceModal: false,
      showBulkDeleteInvoiceModal: false,
      showImportInvoicesModal: false,
      invoiceFormKey: 0,
      selectedInvoiceId: null,
      rectifyInvoiceId: null,
      cloneInvoiceId: null,
      selectedTableItems: [],
      resetGeneratePdfKey: 0,
      selectedInvoicesToGeneratePDF: [],
      downloadingPDF: false,
      exportingExcel: false,
      invoiceType: 'factura',
      invoiceLogo: null,
      snack: false,
      snackText: '',
      snackColor: 'info',
      showSendInvoiceEmailModal: false,
      sendingInvoiceEmail: false,
      selectedInvoiceToSendByEmail: null,
      formInvoiceEmail: {
        title: null,
        body: null,
        receivers: null,
      },
      rules: {
        required: value => !!value || 'Este campo es obligatorio.',
        number: value => {
          const pattern = /^-?\d+\.?\d*$/;
          return pattern.test(value) || 'Este campo debe ser numérico.';
        },
        counter: value => value.length <= 20 || 'Max 20 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || 'Email inválido';
        },
      },
    };
  },
  mounted() {
    this.getYears();
    this.getLogoBase64();
  },
  computed: {
    clavedat() {
      return this.$store.state.clavedat;
    },
    billingProfileId() {
      return this.$store.getters.currentOpenbillingProfileId;
    },
    summaryInvoiceEmail() {
      return this.selectedInvoiceToSendByEmail
        ? `${this.selectedInvoiceToSendByEmail.code} -- ${
            this.selectedInvoiceToSendByEmail.contact_name
          } -- ${this.selectedInvoiceToSendByEmail.total_amount}€`
        : '';
    },
  },
  methods: {
    showSnackMessage(action, message) {
      this.snackColor = action;
      this.snackText = message;
      this.snack = true;
    },
    getBillingInvoices() {
      this.$refs['openbillingInvoiceTable'].getBillingInvoices();
    },
    getLogoBase64() {
      apiCtrl
        .get(`/openbilling/${this.clavedat}/settings/logo/${this.billingProfileId}/base64`)
        .then(res => {
          this.invoiceLogo = res.data;
        })
        .catch(() => {});
    },
    getYears() {
      const currentDate = new Date();
      let startYear = currentDate.getFullYear();
      const month = currentDate.getMonth() + 1;

      // If it is november or december we add the next year in the range
      if (month >= 11) {
        startYear = startYear + 1;
      }
      let years = [];
      for (let i = 10; i >= 0; i--) {
        years.push({ text: startYear - i, value: startYear - i });
      }
      this.years = years.sort((a, b) => b.value - a.value);
    },
    openNewInvoiceForm() {
      this.showInvoiceModalForm = true;
    },
    closeInvoiceModalForm() {
      this.showInvoiceModalForm = false;
      this.resetInvoiceForm();
    },
    resetInvoiceForm() {
      this.invoiceFormKey++;
      this.selectedInvoiceId = null;
      this.rectifyInvoiceId = null;
      this.cloneInvoiceId = null;
    },
    onSavedInvoice() {
      this.showSnackMessage('success', 'Datos guardados correctamente');
      this.closeInvoiceModalForm();
      this.$refs['openbillingInvoiceTable'].getBillingInvoices();
    },
    onEditInvoice(invoice) {
      this.selectedInvoiceId = invoice.id;
      this.showInvoiceModalForm = true;
    },
    onDeleteInvoice(invoice) {
      if (invoice.blocked) {
        this.showSnackMessage('error', 'La factura está bloqueada');
      } else {
        this.selectedInvoiceId = invoice.id;
        this.showDeleteInvoiceModal = true;
      }
    },
    confirmDeleteInvoice() {
      this.deleteSingleInvoice(this.selectedInvoiceId);
      this.showDeleteInvoiceModal = false;
    },
    closeDeleteInvoiceModal() {
      this.showDeleteInvoiceModal = false;
      this.selectedInvoiceId = null;
    },
    deleteSingleInvoice(id) {
      apiCtrl
        .post(`/openbilling/${this.clavedat}/invoices/delete`, { id: id })
        .then(() => {
          this.closeDeleteInvoiceModal();
          this.$refs.openbillingInvoiceTable.getBillingInvoices();
        })
        .catch(err => {
          console.log(err);
          this.closeDeleteInvoiceModal();
        });
    },
    onRectifyInvoice(invoice) {
      this.rectifyInvoiceId = invoice.id;
      this.showInvoiceModalForm = true;
    },
    onCloneInvoice(invoice) {
      this.cloneInvoiceId = invoice.id;
      this.showInvoiceModalForm = true;
    },
    sendInvoiceByEmail(invoice) {
      this.selectedInvoiceToSendByEmail = invoice;
      this.formInvoiceEmail.title =
        'Tienes una nueva factura [' + this.selectedInvoiceToSendByEmail.code + ']';
      this.formInvoiceEmail.body =
        'Hola!\n' +
        '\n' +
        'Te envío la factura número [' +
        this.selectedInvoiceToSendByEmail.code +
        '] por importe de ' +
        this.selectedInvoiceToSendByEmail.total_amount.toString().replace('.', ',') +
        '€.\n' +
        '\n' +
        '¡Que pases un buen día!';
      this.formInvoiceEmail.receivers = this.selectedInvoiceToSendByEmail.contact_email;
      this.showSendInvoiceEmailModal = true;
    },
    confirmSendInvoiceByEmail() {
      // Validate form
      const validForm = this.$refs.invoiceEmailForm.validate();
      if (validForm) {
        this.sendingInvoiceEmail = true;
        const invoice = this.selectedInvoiceToSendByEmail;
        const emailData = JSON.parse(JSON.stringify(this.formInvoiceEmail));
        emailData.body = emailData.body.replace(/\n/g, '<br/>');
        this.selectedInvoicesToGeneratePDF = [];
        let processedInvoice = this.generateCalculatedTotalSelectedInvoice(invoice);
        this.selectedInvoicesToGeneratePDF.push(processedInvoice);
        this.resetGeneratePdfKey = this.resetGeneratePdfKey + 1;
        const clavedat = this.clavedat;
        setTimeout(async () => {
          const fileName = `Factura_${invoice.code}`;
          let element = document.getElementById('element-to-print');
          let opt = {
            margin: 1,
            filename: `${fileName}.pdf`,
            image: { type: 'jpeg', quality: 1 },
            html2canvas: { scale: 2, backgroundColor: '#ffffff' },
            jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
            pagebreak: { mode: ['avoid-all', 'css', 'legacy'] },
          };
          await html2pdf()
            .set(opt)
            .from(element)
            .toPdf()
            .output('datauristring')
            .then(async function(pdfAsString) {
              let data = {
                title: emailData.title,
                body: emailData.body,
                email: emailData.receivers,
                fileDataURI: pdfAsString,
              };
              await apiCtrl
                .post(`/openbilling/${clavedat}/invoices/send-email/${invoice.id}`, data)
                .then(() => {
                  console.log('success');
                })
                .catch(error => {
                  console.log(error);
                });
            });
          this.getBillingInvoices();
          this.onCloseSendInvoiceEmail();
          this.showSnackMessage('success', 'Se ha enviado el email correctamente');
        }, 2000);
      } else {
        this.showSnackMessage('error', 'Faltan campos obligatorios o algún campo no es válido.');
      }
    },
    onCloseSendInvoiceEmail() {
      this.showSendInvoiceEmailModal = false;
      this.sendingInvoiceEmail = false;
      this.formInvoiceEmail = {
        title: null,
        body: null,
        receivers: null,
      };
    },
    onDownloadPdf(invoice) {
      this.downloadingPDF = true;
      this.selectedInvoicesToGeneratePDF = [];
      let processedInvoice = this.generateCalculatedTotalSelectedInvoice(invoice);
      this.selectedInvoicesToGeneratePDF.push(processedInvoice);
      this.resetGeneratePdfKey = this.resetGeneratePdfKey + 1;
      setTimeout(() => {
        const fileName = `Factura_${invoice.code}`;
        this.generatePDF(fileName);
      }, 2000);
    },
    onBulkDownloadPdf() {
      this.downloadingPDF = true;
      this.selectedInvoicesToGeneratePDF = [];
      this.selectedTableItems.forEach(item => {
        let processedInvoice = this.generateCalculatedTotalSelectedInvoice(item);
        this.selectedInvoicesToGeneratePDF.push(processedInvoice);
      });

      this.resetGeneratePdfKey = this.resetGeneratePdfKey + 1;
      setTimeout(() => {
        const fileName = `Facturas_seleccionadas_${this.resetGeneratePdfKey}`;
        this.generatePDF(fileName);
      }, 2000);
    },
    onSelectedItems(selectedItems) {
      this.selectedTableItems = selectedItems;
    },
    confirmDeleteBulkInvoices() {
      let ids = [];
      this.selectedTableItems.forEach(item => {
        ids = ids.concat(item['id']);
      });
      this.deleteBulkInvoices(ids);
    },
    deleteBulkInvoices(ids) {
      apiCtrl
        .post(`/openbilling/${this.clavedat}/invoices/bulk-delete`, { ids: ids })
        .then(() => {
          this.showBulkDeleteInvoiceModal = false;
          this.getBillingInvoices();
        })
        .catch(err => {
          console.log(err);
          this.showBulkDeleteInvoiceModal = false;
        });
    },
    generateCalculatedTotalSelectedInvoice(invoice) {
      return generateCalculatedTotalSelectedInvoice(invoice);
    },
    createEmptyTotalSelectedInvoiceData() {
      return createEmptyTotalSelectedInvoiceData();
    },
    generatePDF(fileName) {
      let element = document.getElementById('element-to-print');
      let opt = {
        margin: 1,
        filename: `${fileName}.pdf`,
        image: { type: 'jpeg', quality: 1 },
        html2canvas: { scale: 2, backgroundColor: '#ffffff' },
        jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
        pagebreak: { mode: ['avoid-all', 'css', 'legacy'] },
      };
      html2pdf()
        .set(opt)
        .from(element)
        .save();

      this.downloadingPDF = false;
    },
    async exportToExcel() {
      this.exportingExcel = true;
      import('../../../plugins/Export2Excel.js').then(async excel => {
        const pagination = this.$refs['openbillingInvoiceTable'].invoicesPagination;
        const filters = this.$refs['openbillingInvoiceTable'].filters;
        let selectedIds = [];
        if (!this.$refs['openbillingInvoiceTable'].selectAllRows) {
          this.selectedTableItems.forEach(item => {
            selectedIds = selectedIds.concat(item['id']);
          });
        }
        const config = {
          params: {
            page: 1,
            per_page: -1,
            sort_by: pagination.sortBy,
            descending: pagination.descending,
            search: filters.search,
            status: filters.status,
            contact_id: filters.contact_id,
            month: filters.month,
            year: filters.year,
            quarter: filters.quarter,
            payment_method: filters.payment_method,
            doc_type: this.invoiceType,
            selected_ids: selectedIds,
          },
        };

        let headers = [];
        let dataToExport = [];
        await apiCtrl
          .get(`/openbilling/${this.clavedat}/invoices/list/export-excel`, config)
          .then(res => {
            console.log(res.data);
            headers = res.data.headers;
            dataToExport = res.data.data;
          })
          .catch(() => {
            this.showSnackMessage('error', 'Se ha producido un error al exportar los datos');
            this.exportingExcel = false;
          });
        let exportHeaders = headers.map(header => header.text);
        const exportColumns = headers.map(header => header.value);
        const exportList = this.formatJson(exportColumns, dataToExport);
        const quarterFileName = filters.quarter ? `Q${filters.quarter}` : 'año completo';
        excel.export_json_to_excel({
          header: exportHeaders,
          data: exportList,
          filename: `Reporte Facturas`,
          autoWidth: true,
          bookType: 'xlsx',
        });
        this.exportingExcel = false;
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          return v[j];
        }),
      );
    },
    openImportInvoicesModal() {
      this.showImportInvoicesModal = true;
    },
    closeImportInvoicesModal() {
      this.showImportInvoicesModal = false;
      this.keyImportInvoicesModal++;
    },
    onImportedInvoices() {
      this.closeImportInvoicesModal();
      this.getBillingInvoices();
      this.$refs.openbillingInvoiceTable.getContactsList();
    },
  },
  watch: {},
};
</script>

<style scoped>
.v-select.fit {
  width: min-content !important;
}
</style>
